import { type WorkspaceResponseListItem } from '@app/@types/redux/workspace';
import { translate } from '@state/utils/helper';
import { DropdownMenu } from 'radix-ui';
import { BsThreeDots } from 'react-icons/bs';
import { PiCertificateDuotone, PiFoldersDuotone, PiReceiptDuotone } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import { i18nCText } from '../../libs/i18n/I18n';
import { Card, CardBody, Image } from '../UI/Html';

interface WorkspaceItemProps {
  item: WorkspaceResponseListItem;
}

const WorkspaceItem = ({ item }: WorkspaceItemProps) => {
  return (
    <Card className="w-100">
      <div className="project__item__imageContainer">
        <Link to={`/workspace/${item.workspace.id}`}>
          <Image
            alt="..."
            src={item.workspace.attributes.image || '/assets/img/placeholder.jpg'}
            className="project__item__image"
          />
        </Link>
      </div>
      <CardBody className="pt-2 pb-3 pl-3 pr-2">
        <div className="d-flex">
          <div className="text_overlap">
            <small className="text-muted">By {item.owner}</small>
          </div>
          <div className="ml-auto ">
            <DropdownMenu.Root>
              <DropdownMenu.Trigger asChild>
                <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: 'transparent',
                    margin: 0,
                    padding: '0px 8px',
                    boxShadow: 'none',
                    border: 'none',
                  }}
                  aria-label="Customise options"
                >
                  <BsThreeDots size={15} />
                </button>
              </DropdownMenu.Trigger>
              <DropdownMenu.Portal>
                <DropdownMenu.Content className="DropdownMenuContent" sideOffset={5} align="start">
                  <DropdownMenu.Arrow className="DropdownMenuArrow" />
                  <DropdownMenu.Item asChild className="DropdownMenuItem">
                    <Link color="link" to={`/workspace/${item.workspace.id}`}>
                      <PiFoldersDuotone />
                      <span>{translate('workspace.viewSimulations')}</span>
                    </Link>
                  </DropdownMenu.Item>
                  {item.invoiceUrl ? (
                    <DropdownMenu.Item asChild className="DropdownMenuItem">
                      <Link color="link" to={item.invoiceUrl} target="_blank">
                        <PiReceiptDuotone />
                        <span>{translate('workspace.viewInvoice')}</span>
                      </Link>
                    </DropdownMenu.Item>
                  ) : null}
                  {item.certificateUrl ? (
                    <DropdownMenu.Item asChild className="DropdownMenuItem">
                      <Link color="link" to={item.certificateUrl} target="_blank">
                        <PiCertificateDuotone />
                        <span>{translate('workspace.viewCertificate')}</span>
                      </Link>
                    </DropdownMenu.Item>
                  ) : null}
                </DropdownMenu.Content>
              </DropdownMenu.Portal>
            </DropdownMenu.Root>
            {/* <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-sm"
                style={{
                  backgroundColor: 'transparent',
                  margin: 0,
                  padding: '0px 8px',
                  boxShadow: 'none',
                  border: 'none',
                }}
              >
                <BsThreeDots size={15} />
              </DropdownToggle>
              <DropdownMenuReactStrap>
                <DropdownItem color="link" tag={Link} to={`/workspace/${data.id}`}>
                  <PiFoldersDuotone />
                  <span>{translate('workspace.viewSimulations')}</span>
                </DropdownItem>
              </DropdownMenuReactStrap>
            </UncontrolledDropdown> */}
          </div>
        </div>
        <h3 className="mb-0 h3 text-wrapping">{i18nCText(item.workspace.attributes.name)}</h3>
      </CardBody>
    </Card>
  );
};

export default WorkspaceItem;
